module.exports = __webpack_public_path__ + "static/media/edit.5c149c56.svg";